import stepper1 from '../../Assets/Images/stepper/stepper1.svg'
import stepper2 from '../../Assets/Images/stepper/stepper2.svg'
import { SITEAPPROVED, SITEREJECTED } from '../../layouts/SystemsEnrollment/constant'

const getStepDescription = (currentStep, status) => {
  return currentStep === 1 && status === SITEAPPROVED ? 'Good Job! Once verification is approved by Enphase, the site is successfully enrolled into the program' : steps[currentStep].description
}

const steps = [
  {
    img: stepper1,
    description: 'Add a new system on homeowner’s behalf and submit the application for Enphase verification',
  },
  {
    img: stepper2,
    description: 'Once verification is approved by Enphase, the site is successfully enrolled into the program',
  },
]

const labelMapper = {
  [SITEAPPROVED]: 'Verification successful by Enphase',
  [SITEREJECTED]: 'Verification failed by Enphase',
}

const stepsMapper = {
  [SITEREJECTED]: 'Verification by Enphase'
}

const stepperMapper = {
  [SITEAPPROVED]: 'Verification by Enphase',
  [SITEREJECTED]: 'Verification by Enphase',
}

const getLabel = (label, status) => {
  if (stepperMapper[status] === label && (status === SITEAPPROVED || status === SITEREJECTED)) {
    return labelMapper[status]
  }
  return label
}

export {
  steps,
  getLabel,
  stepsMapper,
  getStepDescription
}